import Swal from 'sweetalert2'
import {
    REGISTER_EMAIL, SEND_CODE, REGISTER_USER, ECONOMIC_ACTIVITIES, GET_CATEGORIES, IS_LOADING_ECONOMIC_ACTIVITIES, PERSONAL_CODE_REFERAL, PERSONAL_CODE_REFERAL_ERROR, PERSONAL_CODE_REFERAL_CLEAN
} from './types'
import { urlServer } from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
import localStorage from '../utils/hooks/useLocalStorage';

//register actions, send email and code
export const sendEmail = (code, history,) => async dispatch => {
    //console.log()
    await fetch(`${urlServer}static-routes/verify-code`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //  credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            code: code
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            var errorType = respJson.error
            var success = respJson.success


            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: REGISTER_EMAIL,
                payload: { success, errorType }
            })

            if (respJson.success === true) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Registro completo'
                })

                history.push({
                    pathname: '/'
                })
            }


        })

        .catch(error => {
            console.log()
        })

}
export const cleanCodeReferal = () => dispatch => {
    dispatch({
        type: PERSONAL_CODE_REFERAL_CLEAN
    })
}
export const checkCodeReferal = (code, history,) => async dispatch => {
    //console.log()
    await fetch(`${urlServer}static-routes/verify-personal-code`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //  credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            code: code
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success) {
                dispatch({
                    type: PERSONAL_CODE_REFERAL,
                    payload: respJson.data
                })
            } else {
                dispatch({
                    type: PERSONAL_CODE_REFERAL_ERROR
                })
            }


        })

        .catch(error => {
            console.log()
        })

}
export const sendCode = (user, history) => async dispatch => {

    await fetch(`${urlServer}static-routes/register`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //  credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(user) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            var errorType = respJson.error
            var success = respJson.success
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: SEND_CODE,
                payload: { success, errorType }
            });
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'success',
                title: 'Se ha enviado un código de verificación a tu correo'
            })


        })
        .catch(error => {
            console.log()
        })
}

export const sendRegisterUser = (registerUser, history) => async dispatch => {
    console.log()

    const formData = new FormData();
    formData.append('email', registerUser.email)
    formData.append('picture', registerUser.picture)
    formData.append('name', registerUser.name)
    formData.append('lastname', registerUser.lastname)
    formData.append('birthDate', registerUser.birthDate)
    formData.append('password', registerUser.password)

    formData.append('phone', registerUser.phone)
    //  ubication: { originCity: originCity, currentCity: currentCity },

    // birthday: [year, month, day].join('-'),
    formData.append('isAcceptTerms', true)
    formData.append('gender', registerUser.gender)
    if (registerUser.referralCode) {
        formData.append("referralCode", registerUser.referralCode)
    }


    await fetch(`${urlServer}static-routes/register`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //  credentials: 'include',
        headers: {

            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData// body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            var errorType = respJson.error
            if (respJson.data)

                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: REGISTER_USER,
                    payload: { registerUser, errorType }
                });
            console.log()
            if (respJson.success === true) {
                //localStorage().setItem("statusLog", true);
                console.log();
                history.push({
                    pathname: '/RegisterCodeVerification',
                    state: {
                        user: registerUser
                    }
                })
            }
            if (respJson.success === false) {

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                if (respJson.error.msg === "MSJ003") {
                    Toast.fire({
                        icon: 'error',
                        title: 'Ya existe un usuario con este correo'
                    })
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Fallo en el registro, inténtelo de nuevo'
                    })
                }



            }

        })
        .catch(error => {

        })


}

export const sendRegisterMark = (formData, history) => async dispatch => {
    console.log()
    for (var pair of formData.entries()) {
        console.log();
    }
    await fetch(`${urlServer}api/trademark/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //  credentials: 'include',
        headers: {
            // 'Content-Type': 'application/json',
            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            var errorType = respJson.error
            console.log()
            var registerMark = respJson.data
            if (respJson.data) {
                localStorage().setItem("nameUser", respJson.data.name)
                localStorage().setItem("lastNameUser", respJson.data.lastName)
                localStorage().setItem("idUser", respJson.data._id);
                localStorage().setItem("isAuthenticated", respJson.data.isAuthenticated)
                localStorage().setItem("picturProfile", respJson.data.profilePicture);
                localStorage().setItem("typeUser", respJson.data.type)
            }
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: REGISTER_USER,
                payload: { formData, errorType }
            });
            console.log()
            if (respJson.success === true) {
                localStorage().setItem("statusLog", true);
                history.push('/Mark/Welcome')
            }
            console.log()
            if (respJson.success === false) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Fallo en el registro, intentelo de nuevo'
                })
                history.push('/')
            }

        })
        .catch(error => {
            console.log()
        })

}

export const sendRegisterMarkExternal = (formData, history) => async dispatch => {
    for (var pair of formData.entries()) {
        console.log();
        console.log()
    }
    await fetch(`${urlServer}api/user/manage-external-user`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //  credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            var errorType = respJson.error
            console.log()
            var registerMark = respJson.data
            if (respJson.data) {
                localStorage().setItem("nameUser", respJson.data.name)
                localStorage().setItem("lastNameUser", respJson.data.lastName)
                localStorage().setItem("idUser", respJson.data._id)
                localStorage().setItem("isAuthenticated", respJson.data.isAuthenticated)
                let picture;
                if (respJson.data.picture) {
                    picture = respJson.data.picture.url ? respJson.data.picture.url.small ? respJson.data.picture.url.small : respJson.data.picture.url.origin : respJson.data.picture;

                } else {
                    picture = ""

                }
                localStorage().setItem("picturProfile", picture)
                localStorage().setItem("typeUser", respJson.data.type)
            }
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: REGISTER_USER,
                payload: { formData, errorType }
            });
            console.log()
            if (respJson.success === true) {
                localStorage().setItem("statusLog", true);
                history.push('/Mark/Welcome')
            }
            console.log()
            if (respJson.success === false) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Fallo en el registro, intentelo de nuevo'
                })
                history.push('/')
            }

        })
        .catch(error => {
            console.log()
        })

}


export const searchEconomicActivities = (search) => async dispatch => {
    console.log()
    await fetch(`http://3.22.99.114/api/economic-activities/search`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.,
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
            search: search,
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            dispatch({
                type: IS_LOADING_ECONOMIC_ACTIVITIES,
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ECONOMIC_ACTIVITIES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}

export const getCategories = () => async dispatch => {

    await fetch(`${urlServer}api/trademark/get-types-brands`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.,
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        }
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_CATEGORIES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}